import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "rask-button-stack",
    templateUrl: "./button-stack.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./button-stack.component.scss"]
})
export class ButtonStackComponent {

}
